import { MatPaginatorI18nService } from './../services/i18n/mat-paginator-i18n.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';

import { AppRoutingModule } from './../app-routing.module';
import { TopnavComponent } from './layouts/topnav/topnav.component';
import { MaterialModule } from '../material/material.module';
import { FooterComponent } from './layouts/footer/footer.component';
import { TokenInterceptor } from './auth/interceptors/token-interceptor.service';
import { HttpLoaderFactory } from '../shared/utils/translateUtils';
import { LocaleInterceptor } from './auth/interceptors/locale-interceptor.service';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layoutcomponent';

@NgModule({
  declarations: [
    TopnavComponent,
    FooterComponent,
    LoginLayoutComponent,
    AppLayoutComponent
  ],
  exports: [
    TopnavComponent,
    FooterComponent,
    LoginLayoutComponent,
    AppLayoutComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocaleInterceptor,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorI18nService
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class CoreModule {}
